// extracted by mini-css-extract-plugin
var _1 = "marker---customLeafletDivIcon---gUhBi";
export { _1 as "customLeafletDivIcon" }
